const ValidPassword = (password) => {
  const password_regex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
  return password_regex.test(password);
};
export default ValidPassword;
